<template>
    <div :class="classLG">
        <div class="card">
            <span :class="{'free' : packCountryDomain.isFree}" class="badge font-12 w-100 " v-if="showButton">
                <span :class="{'white' : !packCountryDomain.isFree}">
                    {{titles.free}}
                </span>
            </span>
            <div class="card-body pack">
                <div class="pricingTable1 text-center packTypePack">
                    <h6 v-if="packCountryDomain.typePack"
                        :class="{'addPack' : btnAction === titles.add}" class="title1 py-3 m-0">
                        {{packCountryDomain.typePack.label}}
                    </h6>
                    <div class="p-3 m-2" style="padding-bottom: 0px !important;margin-bottom: 0px !important;">
                        <h6 :class="{'addPack' : btnAction === titles.add}"
                            class="amount amount-border d-inline-block" v-if="!packCountryDomain.isFree">
                            {{country.currency}} {{price}}
                        </h6>
                        <h6 :class="{'addPack' : btnAction === titles.add}"
                            class="amount amount-border d-inline-block" v-if="packCountryDomain.isFree">
                            {{titles.free}}
                        </h6>
                    </div>
                    <div>
                        <small class="font-14 text-muted" style="margin-left: 20%;" v-if="!packCountryDomain.isFree">
                            {{packCountryDomain.subscriptionPeriod}} {{titles.days}}
                        </small>
                    </div>
                    <hr class="hr-dashed"/>

                    <ul style="text-align: initial;color: #555555;font-size: 14px;">
                        <li><strong>{{titles.testPeriod}}</strong>
                            <br>
                            <span v-if="packCountryDomain.freePeriod > 0">
                               <span style="color: #4aecfba8">
                                    <strong> {{packCountryDomain.freePeriod}} </strong>
                               </span>  {{titles.days}}
                            </span>
                            <span v-if="packCountryDomain.freePeriod == -1">
                                {{titles.unlimited}}
                            </span>
                            <span v-if="packCountryDomain.freePeriod == 0">
                                {{titles.NoFreePeriod}}
                            </span>
                        </li>
                        <li v-if="packCountryDomain.country.stripe === false"><strong>{{titles.nbUsers}}</strong>
                            <br> <span style="color: #4aecfba8">
                                <strong> {{packCountryDomain.numberOfUsers}} </strong></span></li>
                        <li><strong>{{titles.nbSupport}}</strong>
                            <br> <span style="color: #4aecfba8">
                                <strong> {{packCountryDomain.technicalSupport}}
                                </strong></span></li>
                    </ul>

                    <button
                            :class="{ 'addPackButton' : btnAction === titles.add}"
                            @click="save()"
                            class="btn py-2 px-5 font-16 btn-standard-gradient"
                            v-if="showButton"
                    >
                        {{btnAction}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {titles} from '../../../utils/general/titles';

    export default {
        name: 'PackTypePack',
        props: {
            packCountryDomain: Object,
            domain: Object,
            country: Object,
            packsToAdd: Array,
            showButton: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                titles,
                btnAction: String,
                packs: this.packsToAdd,
                price: null,
                classLG: 'col-lg-3'
            };
        },
        created() {
            this.packCountryDomain.id ? this.btnAction = titles.update : this.btnAction = titles.add;
            this.price = parseFloat(this.packCountryDomain.price).toFixed(this.packCountryDomain.country.decimalDigits);
            if (!this.showButton) {
                this.classLG = 'col-lg-5';
            }
        },
        methods: {
            save() {
                this.packs = this.packs.map(item => {
                    item.country = this.country;
                    item.domain = this.domain;
                    return item;
                });
                this.$cookies.set('pack', this.packCountryDomain);
                this.$cookies.set('packs', this.packs);
                this.$cookies.set('fromPath', this.$route.path);
                this.$router.push({name: 'detailPack'});
            }
        }
    };
</script>

<style scoped>
    @import '../../../assets/style/css/settings/base.css';
</style>